export default __webpack_public_path__ + "static/media/TabHome.f8202400.png";